import React, { Component } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

import { NotificationAPI } from "api";
import { Loading } from "custom";

import bell from "../../assets/images/svg/bell.svg";
import error from "../../assets/images/svg/error.svg";

import SimpleBar from "simplebar-react";

import 'moment/locale/it';
const moment = require("moment");


/**
 * Mappa entity → URL frontend dove portare al click sulla notifica.
 *
 * Gli avvisi al consulente (dall'8/10/2026, backend: service.avvisiConsulente) sono due e
 * portano tutti e due alla VENDITA del corsista, che e' il posto da cui lo si contatta:
 *   SELL_UNPAID  — non ha saldato ed e' a meta' percorso (poi ogni 5 lezioni)
 *   LEVEL_ENDING — e' a due lezioni dalla fine del livello: c'e' da proporgli il seguito
 * La frase arriva gia' pronta dal server, nella lingua di chi legge.
 */
function urlForEntity(entity, entityId) {
    switch (entity) {
        case "SELL_UNPAID":
        case "LEVEL_ENDING":
            return "/sell/" + entityId;
        case "ASSIGNED_LEAD":
            return "/lead/detail/" + entityId;
        default:
            return "#";
    }
}


class NotificationDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            loading: false,
            notifications: [],
            isOpen: false
        }
    }

    componentDidMount() {
        this.getNotifications();
        this.pollingInterval = setInterval(() => {
            this.getNotifications();
        }, 30000);
    }

    componentWillUnmount() {
        if (this.pollingInterval)
            clearInterval(this.pollingInterval);
    }


    getNotifications() {
        NotificationAPI.list().then((notifications) => {
            this.setState({ notifications: notifications, error: false, loading: false })
        }).catch((err) => {
            this.setState({ error: true, loading: false });
        })
    }

    markRead(id) {
        NotificationAPI.read(id).then(() => {
            this.getNotifications();
        });
    }

    markAllRead() {
        NotificationAPI.readAll().then(() => {
            this.getNotifications();
        });
    }

    getBadgeNotification(entity) {
        switch (entity) {
            case "SELL_UNPAID":
                return <div className="avatar-xs me-3">
                    <span className="avatar-title bg-soft-warning text-warning rounded-circle fs-16">
                        <i className="bx bx-euro"></i>
                    </span>
                </div>
            case "ASSIGNED_LEAD":
                return <div className="avatar-xs me-3">
                    <span className="avatar-title bg-soft-info text-info rounded-circle fs-16">
                        <i className="bx bx-phone-call"></i>
                    </span>
                </div>
            case "LEVEL_ENDING":
                return <div className="avatar-xs me-3">
                    <span className="avatar-title bg-soft-success text-success rounded-circle fs-16">
                        <i className="bx bxs-graduation"></i>
                    </span>
                </div>
            default:
                return <div className="avatar-xs me-3">
                    <span className="avatar-title bg-soft-secondary text-secondary rounded-circle fs-16">
                        <i className="bx bx-bell"></i>
                    </span>
                </div>
        }
    }

    render() {

        let notifications = this.state.notifications;
        let unreadCount = notifications.filter(item => !item.readed).length;

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.isOpen} toggle={() => this.setState({ isOpen: !(this.state.isOpen) })} className="topbar-head-dropdown ms-1 header-item">
                    <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none">
                        <i className='bx bx-bell fs-22'></i>
                        {(unreadCount > 0) ? <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">{unreadCount}<span
                            className="visually-hidden">notifiche non lette</span></span> : null}
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                        {(this.state.loading) ? <Loading /> : <>
                            <div className="dropdown-head bg-primary bg-pattern rounded-top">
                                <div className="p-3">
                                    <Row className="align-items-center">
                                        <Col>
                                            <h6 className="m-0 fs-16 fw-semibold text-white"> Notifiche </h6>
                                        </Col>
                                        {(unreadCount > 0) ? <div className="col-auto dropdown-tabs">
                                            <span className="badge badge-soft-light fs-13"> {unreadCount} Nuove</span>
                                        </div> : null}
                                    </Row>
                                </div>
                            </div>
                            <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                                {(notifications.length === 0) ? ((!this.state.error) ? <>
                                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                                        <img src={bell} className="img-fluid" alt="user-pic" />
                                    </div>
                                    <div className="text-center pb-5 mt-2">
                                        <h6 className="fs-18 fw-semibold lh-base">Non ci sono notifiche! </h6>
                                    </div>
                                </> : <>
                                    <div className="w-25 w-sm-50 pt-3 mx-auto">
                                        <img src={error} className="img-fluid" alt="user-pic" />
                                    </div>
                                    <div className="text-center pb-5 mt-2">
                                        <h6 className="fs-18 fw-semibold lh-base">Si è verificato un errore :( </h6>
                                    </div>
                                </>) : notifications.map((notification, i) => {
                                    return <div key={i} className={"text-reset notification-item d-block dropdown-item position-relative " + ((!notification.readed) ? "bg-soft-secondary" : "")}>
                                        <Link to={urlForEntity(notification.entity, notification.entity_id)} className="stretched-link" onClick={() => this.markRead(notification.id)}>
                                            <div className="d-flex">
                                                {this.getBadgeNotification(notification.entity)}
                                                <div className="flex-1">
                                                    <h6 className="mt-0 mb-2 lh-base">
                                                        {notification.message}
                                                    </h6>
                                                    <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                        <span><i className="mdi mdi-clock-outline"></i> {moment(notification.createdAt).fromNow()}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                })}
                            </SimpleBar>
                            {(notifications.length > 0 && unreadCount > 0) ? <div className="p-2 border-top text-center">
                                <button type="button" className="btn btn-sm btn-link" onClick={() => this.markAllRead()}>
                                    <i className="ri-check-double-line align-bottom me-1"></i> Segna tutte come lette
                                </button>
                            </div> : null}
                        </>}
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export default NotificationDropdown;
